import type { NetworkPayload } from "../../../composites";

export const API = {
  createInternationalWire: (
    idempotencyKey: UUID,
    {
      amount,
      from_account,
      user,
      destination,
      wire_reason,
      memo,
      note,
      device_id,
      device_request_id,
      quote,
    }: API.CreateSwiftTransaction.Request,
  ): NetworkPayload => {
    return {
      url: `swift_transactions/`,
      options: {
        method: "POST",
        payload: {
          amount,
          from_account,
          user,
          destination,
          wire_reason,
          memo,
          note,
          device_id,
          device_request_id,
          quote,
        },
        idempotencyKey,
      },
    };
  },

  createScheduledInternationalWire: (
    idempotencyKey: UUID,
    payload: API.CreateScheduledSwiftWireTransfer.Request,
  ): NetworkPayload => {
    return {
      url: "swift_transactions/scheduled/",
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },

  fetchInternationalWireReasons: (
    params: API.FetchInternationalWireReasons.Request,
  ): NetworkPayload => {
    const searchParams = new URLSearchParams(
      params.bic ? { bic: params.bic } : { country: params.country! },
    );
    return {
      url: `swift_transactions/payment_codes/?${searchParams.toString()}`,
      options: {
        method: "GET",
      },
    };
  },

  fetchSupportedCurrencies: (): NetworkPayload => {
    return {
      url: `swift_destinations/fx/currencies`,
      options: {
        method: "GET",
      },
    };
  },

  fetchExchangeRateQuote: ({
    specifiedCurrency,
    amount,
    convertedCurrency,
  }: API.FetchExchangeRateQuote.Request): NetworkPayload => {
    const currencyParam = convertedCurrency
      ? `?converted_currency=${convertedCurrency}`
      : "";
    return {
      url: `swift_destinations/fx/quote/${specifiedCurrency}/${amount}${currencyParam}`,
      options: {
        method: "GET",
      },
    };
  },

  createInternationalWireViaTemplate: (
    idempotencyKey: UUID,
    payload: API.CreateSwiftTransactionViaTemplate.Request,
  ): NetworkPayload => {
    return {
      url: `swift_transactions/templates/`,
      options: {
        method: "POST",
        payload,
        idempotencyKey,
      },
    };
  },

  cancelInternationalWire: (uuid: API.SwiftTransactionId): NetworkPayload => {
    return {
      url: `swift_transactions/${uuid}/cancel/`,
      options: {
        method: "POST",
        payload: {},
      },
    };
  },
  cancelScheduledInternationalWire: (
    uuid: API.SwiftTransactionId,
  ): NetworkPayload => {
    return {
      url: `swift_transactions/scheduled/${uuid}/cancel/`,
      options: {
        method: "POST",
        payload: {},
        isJsonResponse: false,
      },
    };
  },
};
